/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { createModel } from '@rematch/core';
import { push, replace } from 'connected-react-router';
import { format, fromUnixTime } from 'date-fns';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';

import { RootModel } from '../index';
import { get, post, put } from '../../api/api';
import PeripheralsState, { TransactionInteface } from '../../interfaces/PeripheralsState';
import BetslipState from 'src/interfaces/BetslipState';
import { apiUrls, replaceUrls } from 'src/api/apiUrls';
import { addCardInfoToBetslip } from 'src/utils/peripheralsHelpers';
import { betsToBetslipFormat, checkError, getParametersTemplate, getParams, objectToQuery } from 'src/utils/utils';

export default createModel<RootModel>()({
  state: {
    omr: {
      omrMockData: false,
      showBetInfo: false,
      commands: {
        mainTests: {
          'Read test': [{ label: 'Get Data', command: 'omr/GETDATA?matrix&apiInfo&apiTestView&fullInfo', showResponse: true }],
          'Cards': [{ label: 'Horses Combo', command:'1' },
            { label: 'Numbers', command:'2', showResponse: true },
            { label: 'Sports Acca', command:'3', showResponse: true },
            { label: 'Dogs UK Combo', command:'4', showResponse: true },
            { label: 'Dogs USA Combo', command:'5', showResponse: true },
            { label: 'Legacy', command:'6', showResponse: true },
            { label: 'Horses Pick', command:'7', showResponse: true },
            { label: 'Horses/Dogs Acca', command:'8', showResponse: true }]
        },
        otherTests: {
          configuration: [{ label: 'request Serial#', command: 'omr/GETDEVICESERIAL', showResponse: true }],
          'Init/Reset': [
            { label: 'RESET', command: 'omr/RESET', showResponse: false },
            { label: 'INIT', command: 'omr/INIT', showResponse: false },
            { label: 'ENABLE', command: 'omr/ENABLED', showResponse: false },
            { label: 'DISABLE', command: 'omr/DISABLE', showResponse: false }
          ],
          'green light': [
            { label: 'On', command: 'omr/GREENON', showResponse: false },
            { label: 'Off', command: 'omr/GREENOFF', showResponse: false },
            { label: 'Flash Fast', command: 'omr/GREENFLASHFAST', showResponse: false },
            { label: 'Flash Slow', command: 'omr/GREENFLASHSLOW', showResponse: false }
          ],
          'red light': [
            { label: 'On', command: 'omr/REDON', showResponse: false },
            { label: 'Off', command: 'omr/REDOFF', showResponse: false },
            { label: 'Flash Fast', command: 'omr/REDFLASHFAST', showResponse: false },
            { label: 'Flash Slow', command: 'omr/REDFLASHSLOW', showResponse: false }
          ],
          motor: [
            { label: 'Forward', command: 'omr/MOTOR_FORWARD', showResponse: false },
            { label: 'Backward', command: 'omr/MOTOR_BACKWARD', showResponse: false },
            { label: 'Stop', command: 'omr/MOTOR_STOP', showResponse: false }
          ],
          Readwait: [{ label: 'Show', command: 'omr/SHOW', showResponse: false }],
          'Eject test': [
            { label: 'Good', command: 'omr/GOOD', showResponse: false },
            { label: 'Fail', command: 'omr/FAILED', showResponse: false }
          ],
          Beeper: [
            { label: 'On', command: 'omr/BEEPERON', showResponse: false },
            { label: 'Off', command: 'omr/BEEPEROFF', showResponse: false },
            { label: 'Once', command: 'omr/BEEPERONCE', showResponse: false }
          ]
        }
      },
      data: {
        matrix: {
          serialDevice: '',
          cardId: '',
          cardName: '',
          columns: 0,
          matrix: []
        },
        card: {},
        infoblock: [],
        testView: [],
        omrBlock: {},
        config: {},
        data: [],
        betFormat: []
      }
    },
    payments: {
      toGet: 0
    },
    transactions: [{
      dateTime: null,
      action: '',
      actionCode: 0,
      value: '',
      addedValue: '',
      info: ''
    }],
    shouldReload: false,
    typeOfCode: 'cardCode',
    isClicked: false,
    pinError: false,
    ticketError: false,
    showReceipt: false,
    overview: [],
    secondScreenTicketCode: null,
    showTicketScanOnly: 1,
    showTicketCodeNoPin: 0,
    showTicketCodeAndPin: 1,
    printReceipts: true,
    printReceiptOnPayout: true,
    reprintTickets: false,
    reprintAnyTicketFromSession: false,
    reprintAnyTicket: false,
    sessionApproval: false,
    closingBalance: 0,
    tillHistory: false,
    payoutUnderBalance: false,
    confirmPayoutUnderBalance: true,
    transferUnderBalance: false,
    autoTransactions: [],
    confirmTransferUnderBalance: false
  } as PeripheralsState,

  reducers: {
    setData(state, payload: PeripheralsState['omr']['data']) {
      return { ...state, omr: { ...state.omr, data: { ...state.omr.data, ...payload } } };
    },

    resetData(state): PeripheralsState {
      return {
        ...state,
        omr: {
          ...state.omr,
          data: {
            matrix: {
              serialDevice: '',
              cardId: '',
              cardName: '',
              columns: 0,
              matrix: []
            },
            card: {},
            infoblock: [],
            testView: [],
            omrBlock: {},
            data: [],
            config: {},
            betFormat: []
          }
        }
      };
    },

    setOmrMockData(state, payload: PeripheralsState['omr']['omrMockData']) {
      return { ...state, omr: { ...state.omr, omrMockData: payload } };
    },

    setReload(state, payload: boolean){
      return { ...state, shouldReload: payload };
    },

    setOverview(state, payload: PeripheralsState['overview']){
      return { ...state, overview: payload };
    },

    setMatrix(state, payload: PeripheralsState['omr']['data']['matrix']) {
      return {
        ...state,
        omr: {
          ...state.omr,
          data: {
            ...state.omr.data,
            matrix: payload
          }
        }
      };
    },

    setShowReceipt(state, payload: boolean){
      return { ...state, showReceipt: payload };
    },

    setBetInfo(state, payload: PeripheralsState['omr']['showBetInfo']){
      return { ...state, omr: { ...state.omr, showBetInfo: payload } };
    },

    setBalance(state, payload: number){
      return { ...state, payments: { ...state.payments, toGet: payload } };
    },

    setTransactions(state, payload: TransactionInteface[]){
      return { ...state, transactions: payload };
    },

    setPinError(state, payload:boolean){
      return { ...state, pinError: payload };
    },

    setTicketError(state, payload:boolean){
      return { ...state, ticketError: payload };
    },

    setTicketCode(state, payload: number){
      return { ...state, secondScreenTicketCode: payload };
    },

    setNewMatrixGrid(state, payload: PeripheralsState['omr']['data']['matrix']['matrix']){
      return {
        ...state,
        omr: {
          ...state.omr,
          data: {
            ...state.omr.data,
            matrix: {
              ...state.omr.data.matrix,
              matrix: payload
            }
          }
        }
      };
    },

    setTypeOfCode(state, payload: PeripheralsState['typeOfCode']){
      return {
        ...state,
        typeOfCode: payload
      };
    },

    changeClick(state, payload: boolean){
      return {
        ...state,
        isClicked: payload
      };
    },

    setSessionApproval(state, payload: boolean){
      return {
        ...state,
        sessionApproval: payload
      };
    },

    setTillHistory(state, payload: boolean){
      return {
        ...state,
        tillHistory: payload
      };
    },

    setClosingBalance(state, payload: number){
      return {
        ...state,
        closingBalance: payload
      };
    },

    addAutoTransactions(state, payload:PeripheralsState['autoTransactions']){
      return {
        ...state,
        autoTransactions: payload
      };
    }
  },

  effects: (dispatch) => ({
    async getReaderResponse(payload): Promise<void> {
      try {
        dispatch.peripherals.changeBetInfo(false);
        const { command } = payload;
        const tillCode = localStorage.getItem('tillCode');

        if (isNaN(+command)){
          const character = command.includes('?') ? '&' : '?';
          const response = await get(`/${ command }${ character }till=${ tillCode }`, 'tillUrl');
          const data = JSON.parse(JSON.stringify(response.data));

          if (_.some(data.TillApiResponse.infoblock, { infoType: 1 }) || data.TillApiResponse.config || data.TillApiResponse.length > 1 ||
          (command === 'TILLSTATUS' && !_.isEmpty(data.TillApiResponse.status))){
            dispatch.peripherals.changeBetInfo(true);
            dispatch.peripherals.setData(data.TillApiResponse);
            await dispatch.peripherals.getLastMatrix();
          } else if (data.TillApiResponse.matrix){
            dispatch.peripherals.changeBetInfo(false);
            dispatch.peripherals.submitNewMatrix({ matrix: JSON.stringify(data.TillApiResponse.matrix.matrix) });
          } else {
            const { bets, slip, selectionType, stake, system, bankerBets, isStakeTotal } = addCardInfoToBetslip(data.TillApiResponse);
            await dispatch.betslip.addBets(bets);
            dispatch.betslip.changeSlip(slip);
            dispatch.betslip.changeStakeSelection(selectionType);

            if (isStakeTotal || selectionType === 'totalStake'){
              dispatch.betslip.updateBetStake({ key: 'totalStake', value: stake });
            }

            if (slip === 2){
              await dispatch.betslip.addMultipleSelectedCombinations(system);
            }

            if (bankerBets.length > 0){
              await dispatch.betslip.updateBankerByBets(bankerBets);
            }
          }
        } else {
          dispatch.peripherals.getCardbyId(+command);
        }
      } catch (error) {
        //TODO Handle Error
      }
    },

    async getDrawerStatus(): Promise<boolean>{
      try {
        const tillCode = localStorage.getItem('tillCode');
        const response = await get(`/TILLSTATUS?till=${ tillCode }`, 'tillUrl');
        const status = response.data.TillApiResponse.status.drawer;
        if (status && status !== 'noDrawer'){
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    },

    async submitNewMatrix(payload: {matrix: string}): Promise<void> {
      try {
        let response = null;
        const { matrix } = payload;
        const tillCode = localStorage.getItem('tillCode');
        response = await post(`/MATRIX?card&matrix&apiInfo&till=${ tillCode }`, { matrix: JSON.parse(matrix) }, 'tillUrl');

        const data = JSON.parse(JSON.stringify(response.data));
        const tillApi = data?.TillApiResponse;
        dispatch.peripherals.setData(tillApi);

        if (tillApi) {
          const { bets, slip, selectionType, stake, system, bankerBets, isStakeTotal } = addCardInfoToBetslip(tillApi);
          await dispatch.betslip.addBets(bets);
          dispatch.betslip.changeSlip(slip);
          dispatch.betslip.changeStakeSelection(selectionType);

          if (isStakeTotal || selectionType === 'totalStake'){
            dispatch.betslip.updateBetStake({ key: 'totalStake', value: stake });
          }

          if (slip === 2){
            await dispatch.betslip.addMultipleSelectedCombinations(system);
          }

          if (bankerBets.length > 0){
            await dispatch.betslip.updateBankerByBets(bankerBets);
          }
        }
      } catch (error){
        //TODO Handle Error
      }
    },

    async getCardbyId(cardId: number): Promise<void> {
      try {
        const tillCode = localStorage.getItem('tillCode');
        const response = await get(`/omr/EMPTYMATRIX?cardId=${ cardId }&till=${ tillCode }`, 'tillUrl');
        const data = JSON.parse(JSON.stringify(response.data));
        const tillApi = data?.TillApiResponse;
        dispatch.peripherals.resetCoupon();
        dispatch.peripherals.setMatrix(tillApi.matrix);

      } catch (error) {
        //TODO Handle Error
      }
    },

    resetCoupon(): void {
      dispatch.peripherals.resetData();
    },

    async changeOmrMockData(payload): Promise<void> {
      dispatch.peripherals.setOmrMockData(payload);
      if (payload){
        dispatch.peripherals.getLongPoll();
      }
    },

    async resetMatrix(payload, state): Promise<void> {
      const { matrix } = state.peripherals.omr.data.matrix;
      const newMatrix = _.map(matrix, r => _.map(r, (row, index) => index !== r.length - 1 ? row.replace('1', '0') : row).join(''));
      dispatch.peripherals.resetCoupon();
      dispatch.peripherals.setMatrix({ ...state.peripherals.omr.data.matrix, matrix: newMatrix });
    },

    async changeMatrix(payload, state): Promise<void> {
      const { ci, li } = payload;
      const { matrix } = state.peripherals.omr.data.matrix;
      const replacement = matrix[ci][li] === '0' ? '1' : '0';
      const newMatrix = JSON.parse(JSON.stringify(matrix));
      const newRow = matrix[ci].substring(0, li) + replacement + matrix[ci].substring(li + 1);
      newMatrix[ci] = newRow;

      dispatch.peripherals.setNewMatrixGrid(newMatrix);
    },

    async getLastMatrix() {
      try {
        const tillCode = localStorage.getItem('tillCode');
        const response = await get(`/omr/LASTMATRIX?till=${ tillCode }`, 'tillUrl');
        const data = JSON.parse(JSON.stringify(response.data));
        const matrix = data.TillApiResponse.matrix.matrix;
        const matrixInfo = await post('/MATRIX?card&matrix&apiInfo', { matrix }, 'tillUrl');
        const matrixData = JSON.parse(JSON.stringify(matrixInfo.data));
        const tillApi = matrixData?.TillApiResponse;
        dispatch.peripherals.setData(tillApi);

      } catch (error) {
        //TODO: Handle error.
      }
    },

    async getLongPoll(payload, state) {
      try {
        const { omrMockData } = state.peripherals.omr;

        if (!omrMockData){
          dispatch.events.setLoading(false);
          const tillCode = localStorage.getItem('tillCode');
          const response = await get(`/TILLSTATUS?till=${ tillCode }`, 'tillAwait');

          if (response) {
            const data = JSON.parse(JSON.stringify(response.data));
            const tillApi = data?.TillApiResponse;
            if (tillApi.status.omrData === true) {
              await this.getReaderResponse({ command: 'omr/GETDATA?matrix' }); // If we have information on reader we fetch the new data
            }
            dispatch.peripherals.getLongPoll();
          }
        }
      } catch (error){
        //TODO: HANDLE ERROR
      }
    },

    async checkValidPrinter():Promise<{status: number }> {
      try {

        if (localStorage.getItem('fakeTill') === 'true'){
          return { status: 200 };
        }

        const response = await get('/TILLSTATUS', 'tillUrl');
        const defaultPrinter = _.find(response.data.TillApiResponse.status.printer, { inConfig: true });

        if (!defaultPrinter){
          dispatch.toast.showToast({ type: 'error', message: 'No default printer in config' });
          dispatch.betslip.setProcessing(false);
          return { status: 500 };
        }
        delete defaultPrinter.inConfig;
        const errors = [];

        for (const key in defaultPrinter){
          if (defaultPrinter[key]){

            let error = key === 'isOff' ? 'Printer is off' : 'Printer has no paper';
            if (key === 'lidOpen'){
              error = 'The printer lid is open';
            }
            errors.push(error);
          }
        }

        if (errors.length > 0){
          const printerErrors = 'Printer Error - ' + errors.join(' - ');
          dispatch.toast.showToast({ type: 'error', message: printerErrors });
          dispatch.betslip.setProcessing(false);
          return { status: 500 };
        }

        return { status: 200 };
      } catch (error){
        dispatch.toast.showToast({ type: 'error', message: 'OOOOPS! Something went wrong' });
        return { status: 500 };
      }
    },

    async changeBetInfo(showBetInfo: boolean){
      await dispatch.peripherals.setBetInfo(showBetInfo);
    },

    async ticketReprint(payload):Promise<boolean>{
      try {
        const response = await post(apiUrls.reprint, payload);
        if (response.status === 200) {
          dispatch.peripherals.submitToPrinter(response.data.results);
          return true;
        } else if (response.status === 401) {
          dispatch.toast.showToast({ type: 'error', message: 'Incorrect pin' });
          return false;
        }
        const message = checkError(response.data.results);
        dispatch.toast.showToast({ type: 'error', message });
        return false;
      } catch (e){
        dispatch.toast.showToast({ type: 'error', message: 'Ticket not found' });
        return false;
      }
    },

    async submitToPrinter(submitResult: BetslipState['betResult']) {
      try {
        await post('/printer/PRINTTXT', submitResult, 'tillUrl');
      } catch (error) {
        // TODO: HANDLE ERROR
      }
    },


    async getTillTransactions(payload, state){
      try {
        const response =  await get(replaceUrls(apiUrls.tillHistory, { tillId: localStorage.getItem('tillId') }));

        const history = _.map(response.data.results, (result) => {
          const date = (result.timeDate.toString()).split('.')[0];

          const line = {
            dateTime: format(utcToZonedTime(fromUnixTime(+date), state.odds.selectedTimezone), 'EEE, dd MMM - HH:mm'),
            action: result.action,
            info: (result.info).toString(),
            value: result.actionCode === 2 ? `+${ (result.value / 100).toFixed(2) }` : `${ (result.value / 100).toFixed(2) }`,
            addedValue: (result.addedValue / 100).toFixed(2)
          };
          return line;
        });

        dispatch.peripherals.setTransactions(history);
      } catch (error) {
        //TODO: handle error
      }
    },

    async getLastTickets(payload){
      try {
        const response =  await get(replaceUrls(apiUrls.getLastTickets+ `?date=${ payload }`, { till: localStorage.getItem('tillId') }));
        if (response.status === 200){

          const { collection } = response.data.results;
          return collection;
        }
        return [];
      } catch (error) {
        //TODO: handle error
      }
    },

    async getTicketDetails(payload: { ticket: number, pin?: number}, state):Promise<any>{
      try {
        const hasPin = state.peripherals.isClicked && state.peripherals.showTicketCodeAndPin === 1;
        const response =  await get(replaceUrls(apiUrls.getTicketDetails, {
          ticket: payload.ticket,
          pin: hasPin ? payload.pin : -1
        }));

        if (response.status === 200){
          dispatch.peripherals.changeClick(false);

          return response.data.results;
        } else if (response.status === 401){
          dispatch.toast.showToast({ type: 'error', message: 'incorrect pin' });
          dispatch.peripherals.changeClick(false);
          return 'pinError';
        }
        dispatch.peripherals.changeClick(false);
        return [];
      } catch (error) {
        dispatch.peripherals.changeClick(false);

        return null;
        //TODO: handle error
      }
    },

    async getTillBalance(): Promise<void> {
      try {
        const response = await get(replaceUrls(apiUrls.tillBalance, { tillId:  localStorage.getItem('tillId') }));
        dispatch.peripherals.setBalance(response.data.results[0].addedValue);
      } catch (error) {
        //TODO: handle error
      }
    },

    async getSessionBalance(payload){
      try {
        const response = await get(replaceUrls(apiUrls.sessionBalance, { sessionId: payload.sessionId }));
        if (response && response.status === 200){
          return response.data.results[0];
        }
        return null;
      } catch (error) {
        return null;
      }
    },

    async sendTillCommand(payload): Promise<void> {
      try {
        await post(replaceUrls(apiUrls.sendTillCommand, { tillId: localStorage.getItem('tillId') }), payload);
        await this.getTillBalance();
      } catch (error) {
        //TODO: handle error
      }
    },

    async submitFicaForm(payload){
      try {
        const date = payload.date ? payload.date : new Date().toISOString().split('T')[0];
        const dateString = date + ' ' + payload.time + 'z';
        const ficaForm = {
          transactionType: payload.transactionType,
          reference: payload.reference,
          firstName: payload.firstName,
          lastName: payload.lastName,
          user: localStorage.getItem('tilluserId'),
          till: localStorage.getItem('tillId'),
          address: payload.address,
          identification: payload.idNumber,
          transactionAmount: (+payload.transactionAmount) * 100,
          transactionDate: new Date(dateString).getTime() / 1000,
          contact: payload.contact
        };
        const response = await post(apiUrls.ficaForm, ficaForm);
        if (response && response.status === 200){
          dispatch.toast.showToast({ type: 'success', message: (response && response.data.message) });
          dispatch(replace('/'));
        } else {
          const message = checkError(response.data.results || 'OOOPS!! Something went wrong');
          dispatch.toast.showToast({ type: 'error', message });
        }
      } catch (e) {
        //TODO: HANDLE ERRORS
      }
    },

    async reprintLastTicket(){
      try {
        const tillId = localStorage.getItem('tillId');
        const response = await get(`/printer?till=${ tillId }`, 'tillUrl');
        const data = JSON.parse(JSON.stringify(response.data));

        dispatch.peripherals.submitToPrinter(data);
      } catch (e){
        //TODO: HANDLE ERRORS
      }
    },

    async assignTicket(payload){
      try {
        const response = await post(replaceUrls(apiUrls.assignTicket), { ticket: payload.ticket, account: payload.account });

        if (response.status === 200){
          return true;
        }
        return false;
      } catch (e){
        return false;
        //TODO: HANDLE ERRORS
      }
    },

    async testPrinter(){
      try {
        const response = await get('/printer/TESTTICKET', 'tillUrl');
        const data = JSON.parse(JSON.stringify(response.data));

        dispatch.peripherals.changeBetInfo(true);
        dispatch.peripherals.setData(data.TillApiResponse);
      } catch (e){
        //TODO: HANDLE ERRORS
      }
    },

    async cancelTicket(payload, state){
      const hasPin = state.peripherals.isClicked;
      const tillId = localStorage.getItem('tillId');

      const response = await post(replaceUrls(apiUrls.cancelTicket), {
        ticket: payload.ticket,
        pin: hasPin ? payload.pin : -1,
        tillId
      });
      dispatch.peripherals.changeClick(false);

      if (response && response.status === 200){
        dispatch.toast.showToast({ type: 'success', message: (response && response.data.message) });
        dispatch.peripherals.getTillTransactions();
        dispatch.peripherals.getTillBalance();
      } else if (response.data.message && response?.data?.message.includes('PIN')){
        dispatch.peripherals.setPinError(true);
      } else if (response && response.data) {
        const message = checkError(response.data.results);
        dispatch.toast.showToast({ type: 'error', message: message });
      } else {
        dispatch.peripherals.setTicketError(true);
      }
    },

    async setClicked(payload){
      dispatch.peripherals.changeClick(payload);
    },

    async payoutTicket(payload, state){
      try {

        const hasPin = state.peripherals.isClicked;
        const tillId = localStorage.getItem('tillId');

        const response = await put(replaceUrls(apiUrls.payoutTicket), {
          ticket:payload.ticket,
          pin: hasPin ? payload.pin : -1,
          tillId
        });

        dispatch.peripherals.changeClick(false);

        if (response && response.status === 200){
          dispatch.peripherals.setShowReceipt(true);
          dispatch.toast.showToast({ type: 'success', message: (response && response.data.message) });
          dispatch.peripherals.getTillTransactions();
          dispatch.peripherals.getTillBalance();

          if (state.peripherals.printReceiptOnPayout && localStorage.getItem('fakeTill') !== 'true'){
            dispatch.peripherals.payoutReceipt(payload.ticket);
          }

        } else if (response.data.results.code === 403){
          dispatch.toast.showToast({ type: 'error', message: response.data.results.message });
        } else if (response?.data?.message?.includes('PIN')){
          dispatch.peripherals.setPinError(true);
        } else if (response && response.data && response.data.results.message){
          dispatch.toast.showToast({ type: 'error', message: response.data.results.message });

        } else if (response && response.data){
          const error = response.data.results;
          for (const key in error.validation?.fieldErrors){
            dispatch.toast.showToast({ type: 'error', message: (error.validation?.fieldErrors[key] &&
              error.validation?.fieldErrors[key][0]?.message) || error.message });
            return;
          }
          for (const err of error.validation?.nonFieldErrors){
            dispatch.toast.showToast({ type: 'error', message: (err &&
              err.message) || error.message });
          }
        } else {
          dispatch.peripherals.setTicketError(true);
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'OOPS. Something went wrong.' });
      }
    },

    async getTillTransactionHistory(payload, state){
      try {
        const query = objectToQuery({ ...payload }, '', false);

        const response = await get(replaceUrls(apiUrls.tillTransactions + `?${ query }`, { walletId: state.auth.tillWallets[0].id }));
        if (response.status === 200){
          return response.data.results.collection;
        }
        return [];
      } catch (e){
        return [];
      }
    },

    async getAdminTillTransactionHistory(payload){
      try {

        const query = objectToQuery({ ...payload, till: payload.session }, '', false);

        const response = await get(replaceUrls(apiUrls.adminTillTransactions + `?${ query }`));
        if (response.status === 200){
          return response.data.results;
        }
        return [];
      } catch (e){
        return [];
      }
    },

    async getTransactionDescription(payload){
      try {
        const response = await get(replaceUrls(apiUrls.transactionDescription, { id: payload }));
        if (response.status === 200){
          return response.data.results;
        }
        return {};
      } catch (e) {
        return {};
      }
    },

    async compareBalances(payload:{ amount: number }, state){
      await dispatch.peripherals.getOverview();
      const currentBalance = state.peripherals.closingBalance;

      if (currentBalance < +payload.amount && state.peripherals.transferUnderBalance){
        return true;
      } else if (currentBalance < +payload.amount){
        dispatch(push('#transferUnderBalance'));
        return false;
      }
      return true;
    },

    async addTransaction(payload: {
      amount: number,
      divisor: number,
      descriptionParams: {},
      currency: string,
      transactionType: number,
      originTill: string,
      user: string
    }, state){
      let allowed = true;
      if (payload.originTill === localStorage.getItem('tillId')){
        allowed = await dispatch.peripherals.compareBalances({ amount: payload.amount });
      }

      if (allowed){
        try {
          const newPayload = { ...payload, amount: payload.amount * payload.divisor };
          const response = await post(apiUrls.addTransaction, newPayload);
          if (response.status === 200){
            dispatch.toast.showToast({ type: 'success', message: (response && response.data.message) });
          } else {
            dispatch.toast.showToast({ type: 'error', message: (response && response.data.message) });
          }

          return response;
        } catch (e){
          dispatch.toast.showToast({ type: 'error', message: 'Transaction failed' });
          //TODO: Handle error
        }
      }
    },

    async getOverview(payload){
      try {
        const tillId = localStorage.getItem('tillSession');
        const query = objectToQuery(payload, '', false);
        const response = await get(replaceUrls(apiUrls.tillOverView + `?${ query }`, { tillId }));

        if (response.status === 200){
          dispatch.peripherals.setOverview(response.data.results);
          dispatch.peripherals.setClosingBalance(response.data.results[0].closingBalance / 100);
          return response.data.results;
        }
        return response;
      } catch (e){
      //TODO: Handle error
      }
    },

    changeReload(payload){
      dispatch.peripherals.setReload(payload);
    },

    async changeTypeOfCode(payload){
      dispatch.peripherals.setTypeOfCode(payload);
    },

    async getBarcode(payload){
      try {
        await dispatch.events.changeDirtiness(false);
        const response = await get(replaceUrls(apiUrls.scanner, { barcode: payload }));
        if (response.data.results.bcAction === 3 && response.data.results.bcTypeName !== 'bookedBet'){
          dispatch(push(`/get-ticket?code=${ response.data.results.TicketInfo[0].code }`));
        } else if (response.data.results.bcType === 2){
          dispatch(replace(`#customer-login?code=${ response.data.results.customerCardInfo[0].customer.accountNumber }`));
          const number = (response.data.results.barcode.split('1'))[1].replace(/^0+/, '');
          dispatch.auth.addNumberCustomer(number);
          dispatch.content.setShowSecondScreen('');
        } else if (response.data.results.bcAction === 1){
          dispatch(push(`/get-ticket?code=${ response.data.results.TicketInfo[0].code }&payout=true`));
        } else if (response.data.results.bcAction === 2) {
          dispatch(push(`/get-ticket?code=${ response.data.results.TicketInfo[0].code }&cancel=true`));
        } else if (response.data.results.bcTypeName === 'bookedBet'){
          dispatch.betslip.bookBet(response.data.results.registered[0].id);
        } else if (response.data.results.bcTypeName === 'EndOfShift'){
          const barcode = response.data.results.barcode;
          const sessionId = barcode.substring(barcode.length -4, barcode.length - 1);

          dispatch(replace(`/session-admin?session=${ sessionId }`));
        }

      } catch (e){
        //TODO: HANDLE ERROR
      }
    },

    async getCardFromTicket(payload){
      try {
        const response = await get(`/omr/CONVERTTOCARD/${ payload }`, 'tillUrl');
        if (response && response.status === 200){
          const data = JSON.parse(JSON.stringify(response.data));
          const tillApi = data?.TillApiResponse;
          if (tillApi) {
            const { bets, slip, selectionType, stake, system, bankerBets, isStakeTotal } = addCardInfoToBetslip(tillApi);
            await dispatch.betslip.addBets(bets);
            dispatch.betslip.changeSlip(slip);
            dispatch.betslip.changeStakeSelection(selectionType);

            if (isStakeTotal || selectionType === 'totalStake'){
              dispatch.betslip.updateBetStake({ key: 'totalStake', value: stake });
            }

            if (slip === 2){
              await dispatch.betslip.addMultipleSelectedCombinations(system);
            }

            if (bankerBets.length > 0){
              await dispatch.betslip.updateBankerByBets(bankerBets);
            }
          }
          return true;
        }
        return false;
      } catch (e){
        return false;
      }

    },

    async getTillId(){
      try {
        const response = await get('/getTillId', 'tillUrl');
        return response.data.TillApiResponse;
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'No till id' });
        return { tillId: -1 };
      }
    },

    changePinError(payload){
      dispatch.peripherals.setPinError(payload);
    },

    changeTicketError(payload){
      dispatch.peripherals.setTicketError(payload);
    },

    async lastPayout(_, state):Promise<void>{
      try {
        const response = await get(replaceUrls(apiUrls.lastPayout, { walletId: state.auth.tillWallets[0].id }));
        if (response && response.data && response.data.results) {
          await post('/printer/RECEIPT', response.data.results, 'tillUrl');
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'No last payout available' });
      }
    },

    async loadLogo(){
      try {
        const response = await post('/printer/LOADLOGOS', 'tillUrl');
        if (response && response.status === 200){
          dispatch.toast.showToast({ type: 'success', message: 'Logos Loaded' });
        } else {
          dispatch.toast.showToast({ type: 'error', message: 'No Logos Found' });
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'No Logos Found' });
      }
    },

    async printRegister(payload: BetslipState['betResult']){
      try {
        const response = await post('/printer/REGISTER', payload, 'tillUrl');
        if (response && response.status === 200){
          dispatch.toast.showToast({ type: 'success', message: 'Register Printed' });
        } else {
          dispatch.toast.showToast({ type: 'error', message: 'Register not printed' });
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'Register not printedd' });
      }
    },

    async payoutReceipt(payload: string){
      try {
        const response = await get(replaceUrls(apiUrls.getReceipt, { ticket: payload }));
        if (response && response.status === 200){
          const ticketDetails = response.data.results;

          await post('/printer/RECEIPT', ticketDetails, 'tillUrl');
        }
      } catch (e) {
        //TODO: Handle error
      }
    },

    async addBetsToBetslip(payload: number): Promise<void>{
      const response: {
        stakes: any,
        betType: number,
        bets: []
      } = await dispatch.peripherals.getTicketDetails({ ticket: payload });
      const newStakeCombinations: BetslipState['systemSlip']['stakes'] = response.stakes.combinations;

      const bets:any = betsToBetslipFormat(response.bets);
      await dispatch.betslip.addBets(bets);
      if (response.betType === 3){
        await dispatch.betslip.changeSlip(2);
        const selectedLines = [];

        const stakes = [];
        let isStakePerSystem = true;
        const stakePerSystem: number[] = [];
        for (const index in response.stakes.combinations){
          if (response.stakes.combinations[index].stake > 0 && !selectedLines.includes(response.stakes.combinations[index].lines.length)){
            selectedLines.push(response.stakes.combinations[index].lines.length);
          }
          stakes.push({ index: +index, value:response.stakes.combinations[index].stake / 100 });

          if (+index > 0 &&
                response.stakes.combinations[+index].lines.length === response.stakes.combinations[+index -1].lines.length &&
                response.stakes.combinations[index].stake !== response.stakes.combinations[+index -1].stake
          ){
            isStakePerSystem = false;
          }

          if (+index < response.stakes.combinations.length - 1 &&
                 response.stakes.combinations[+index].lines.length !== response.stakes.combinations[+index +1].lines.length && isStakePerSystem){
            stakePerSystem[response.stakes.combinations[index].lines.length -1] = response.stakes.combinations[index].stake;
          }
        }
        if (!isStakePerSystem){
          await dispatch.betslip.updateAllSystemStakes(newStakeCombinations);
          await dispatch.betslip.addMultipleSelectedCombinations(selectedLines);
          await dispatch.betslip.changeStakeSelection('differentStake');
          await dispatch.betslip.updateMultipleSystemStakes(stakes);
        } else if (isStakePerSystem){
          const stakesArray: number[] = Array.from(stakePerSystem, item => item || null);
          await dispatch.betslip.updateAllSystemStakes(newStakeCombinations);
          await dispatch.betslip.addMultipleSelectedCombinations(selectedLines);
          await dispatch.betslip.changeStakeSelection('stakePerSystem');
          await dispatch.betslip.changeStakePerSystem(stakesArray);
          await dispatch.betslip.updateMultipleSystemStakes(stakes);
        }
      }
    },

    async getDenominators(): Promise<void> {
      try {
        const response = await get(replaceUrls(apiUrls.getDenominators));
        return response.data.results;
      } catch (error) {
        //TODO: Handle Error
      }
    },

    async tillSessionOverview(payload:string){
      try {
        const response = await get(`/printer/endOfShift/${ payload }`, 'tillUrl');
        const tillApi = response.data.TillApiResponse?.infoblock;
        if (tillApi[0].infoName!== 'ERROR'){
          return response;
        } else if (!tillApi){
          return { status: 200 };
        } else {
          dispatch.toast.showToast({ type: 'error', message: 'End Shift interrupted by printer connection... Trying again' });
          return { status: 500 };
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'End Shift interrupted by printer connection... Trying again' });
      }
    },

    async endShiftSession(payload, state): Promise<boolean> {
      try {
        const tillSession = localStorage.getItem('tillSession');
        let response = { status: 200 };

        if (!payload.secondTry){
          response = await post(apiUrls.endShifSession, { payload, tillSession });
        }

        let printer = !payload.secondTry ? await dispatch.peripherals.tillSessionOverview(tillSession) : { status: 200 };
        let printerCount = 0;

        while (printerCount <= 9 && printer && printer.status !== 200){
          printer = await dispatch.peripherals.tillSessionOverview(tillSession);
          printerCount+=1;
        }

        if (printerCount > 9 && localStorage.getItem('fakeTill') !== 'true' && !payload.secondTry){
          dispatch.toast.showToast({ type: 'error', message: 'Printer not connected' });
          return false;
        }


        if ((printer && printer.status === 200) || payload.secondTry){

          const transaction =  await dispatch.peripherals.getAutoTransactionPayload({ id:1, amount:null });
          if (transaction && transaction.status === 200){
            await dispatch.auth.tillLogout({ showInactivityMessage: false, hardLogout:true, expired:false  });

            return true;
          }
          return true;
        }

        return false;
      } catch (error) {
        return false;
        //TODO: HANDLE ERROR
      }
    },

    async getSessionDetails(payload){
      try {
        const { sessionId } = payload;
        const response =  await get(replaceUrls(apiUrls.sessionDetails, { sessionId }));

        if (!response || !response.data || response.data.results.length === 0){
          dispatch.toast.showToast({ type: 'error', message: 'Results not found' });
        }
        return response.data.results;
      } catch (error) {
        //TODO: HANDLE ERRORR
      }
    },

    async approveShift(payload){
      try {
        const sessionId = payload.sessionId;
        delete payload.sessionId;

        const response = await post(replaceUrls(apiUrls.approveShift, { sessionId }), { payload });
        const errors = _.filter(response.data.results, { mode: 'failed' });

        if (response.status === 200 && errors.length === 0 && payload.approvedByUserId){
          dispatch.toast.showToast({ type: 'success', message: 'Shift approved' });
          return true;
        } else if (response.status === 200 && errors.length === 0 && !payload.approvedByUserId){
          return true;
        }
        let message = 'Error on';

        for (const error of errors){
          message += `- ${ error.error_msg }`;
        }

        dispatch.toast.showToast({ type: 'error', message  });
        return false;
      } catch (error) {
        //TODO: HANDLE ERROR
        return false;
      }
    },

    async getTransactionTypesHistory(){
      try {
        const session = localStorage.getItem('tillSession');
        const response =  await get(replaceUrls(apiUrls.transactionTypeHistory, { session }));
        if (response.status === 200 && response.data?.results){

          return response.data.results.collection;
        }
        return [];
      } catch (error) {
        //TODO: Handle Error
        return [];
      }
    },

    changeTicketCode(payload){
      dispatch.peripherals.setTicketCode(payload);
    },

    async openDrawer(){
      try {
        const response = await get('/OPENDRAWER', 'tillUrl');

        if (response && response.data){
          const api = response.data.TillApiResponse;
          if ((api.message).includes('configured')){
            dispatch.toast.showToast({ type: 'error', message:api.message   });
          }
        } else {
          dispatch.toast.showToast({ type: 'error', message: 'OOPS!! Something went wrong'  });
        }
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'OOPS!! Something went wrong'  });
      }
    },

    updateSessionApproval(payload: boolean){
      dispatch.peripherals.setSessionApproval(payload);
    },

    updateTillHistory(payload: boolean){
      dispatch.peripherals.setTillHistory(payload);
    },

    async cancelRequest(payload){
      try {
        const response = await post(replaceUrls(apiUrls.cancelRequest), { payload });
        if (response.status === 200){
          dispatch.toast.showToast({ type: 'success', message: 'Request cancelled' });
          return true;
        }

        const message = checkError(response.data.results);
        dispatch.toast.showToast({ type: 'error', message });
        return false;
      } catch (error) {
        dispatch.toast.showToast({ type: 'error', message: 'OOPS!! Something went wrong'  });
        return false;
      }
    },

    async getAutoTransactions(){
      try {
        const response = await get(replaceUrls(apiUrls.autoTransactions));
        if (response.status === 200){
          return response.data.results;
        }

      } catch (error) {
        //TODO: Handle error
      }
    },

    async getTillAutoTransactions(){
      try {
        const tillId = localStorage.getItem('tillId');
        const response = await get(replaceUrls(apiUrls.tillautoTransactions, { tillId }));
        if (response.status === 200){
          return response.data.results;
        }

      } catch (error) {
        //TODO: Handle error
      }
    },

    async getOrganisationTills(){
      try {
        const shopId = localStorage.getItem('shopId');
        const response = await get(replaceUrls(apiUrls.organisationTills, { shopId }));
        if (response.status === 200){
          return response.data.results;
        }

      } catch (error) {
      //TODO: Handle error
      }
    },

    async getWallets(payload){
      try {
        const response = await get(replaceUrls(apiUrls.getWallets, { walletId: payload }));
        return response.data.results.collection;
      } catch (error) {
        //TODO: Handle error
      }
    },

    async getAutoTransactionsFunctions(){
      try {
        const response = await get(replaceUrls(apiUrls.getAutoTransactions));

        if (response && response.status === 200){
          dispatch.peripherals.addAutoTransactions(response.data.results);
        }
      } catch (error) {
        //TODO: HANDLE ERRORS
      }
    },

    async getAutoTransactionPayload(payload: { amount: number | null, id: number, debitParam?: string, creditParam?:string }, state): Promise<any>{
      const { id, amount } = payload;
      const transactionFunction= _.find(state.peripherals.autoTransactions, { id });

      if (!amount && +(state.peripherals.closingBalance) === 0){
        return { status: 200 };
      }

      const debit = !payload.debitParam ? getParams(transactionFunction.debitParam) : payload.debitParam;
      const credit = !payload.creditParam ? getParams(transactionFunction.creditParam) : payload.creditParam;
      const transactionType = transactionFunction.transactionType;
      const walletsData = await get(replaceUrls(apiUrls.getRelevantWallets, { function: id, creditParam: credit, debitParam: debit,
        transactionType }));
      const transactionParameters = getParametersTemplate(walletsData?.data?.results?.parameters);

      const wallets = walletsData?.data?.results?.wallets[0];

      const transactionPayload = {
        transactionType,
        debitWallet: wallets?.debitWalletId,
        creditWallet: wallets?.creditWalletId,
        amount: amount ? +amount * 100 : +(state.peripherals.closingBalance) * 100,
        divisor: 100,
        currency: 'ZAR',
        transactionParameters
      };

      const response = await post(apiUrls.addTransaction, transactionPayload);

      if (response.status === 200){
        dispatch.toast.showToast({ type: 'success', message: (response && response.data.message) });
        return response;
      } else {
        dispatch.toast.showToast({ type: 'error', message: (response && response.data.message) });
        return response;
      }

    }
  })
});
